import { useState } from "react";
import { actualizarResponsables, getAbogados, getEjecutivo, getEjecutivoOperaciones, getResponsables } from "../services/serviceResponsables";
import { selectorTransversal } from "../../../dtos/selector";
import { StatusCode } from "../../../utils/enums";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { ejecutivo } from "../models/operacion";


export interface Responsables {
    ejecutivoComercial: string,
    ejecutivoOperaciones: string,
    abogado: string
};

export interface Ejecutivo {
    id?: number;
    rut: string;
    nombres: string;
    apellidoPaterno: string;
    apellidoMaterno: string;
    activo?: string;
    email?: string;
};

export interface ListaResponsables {
    id?: number;
    rut: string;
    nombres: string;
    apellidopaterno: string;
    apellidomaterno: string;
    activo?: string;
    email?: string;
};


export interface UpdateResponsables {
    rutEjecutivoComercial: string;
    rutEjecutivoOperaciones: string;
    rutAbogado: string;
    mutuoId: number;
};


export function useResponsables() {
    const [responsables, setResponsables] = useState<Responsables>();
    const [abogados, setAbogados] = useState<selectorTransversal[]>([]);
    const [confeccionador, setConfeccionador] = useState<selectorTransversal[]>([]);
    const [ejecutivos, setEjecutivos] = useState<selectorTransversal[]>([]);



    const obtenerResponsables = async (mutuoId: number) => {
        const resp = await getResponsables(mutuoId);
        if (resp && resp.status === 200) {
            const datosResponsables: Responsables = await resp.data;
            setResponsables(datosResponsables);
        }
    };

    const actualizarResponsable = async (data: UpdateResponsables): Promise<void> => {

      const response =  await actualizarResponsables(data);


    }
    const obtenerAbogados = async () => {
        const response :AxiosResponse<ListResponseDto<ListaResponsables>>= await getAbogados();
        if (response && response.status === StatusCode.Ok && Array.isArray(response.data.items)) {
            const datosFiltrados = response.data.items.map((abogado: ListaResponsables) => ({
                label: `${abogado.nombres} ${abogado.apellidopaterno} ${abogado.apellidomaterno}`,
                value: abogado.rut
            }));
            setAbogados(datosFiltrados);
        }
    };

    const obtenerConfeccionador = async () => {
        const response :AxiosResponse<ListResponseDto<ListaResponsables>>= await getEjecutivoOperaciones();
        if (response && response.status === StatusCode.Ok && Array.isArray(response.data.items)) {
            const datosFiltrados = response.data.items.map((confeccionador: ListaResponsables) => ({
                label: `${confeccionador.nombres} ${confeccionador.apellidopaterno} ${confeccionador.apellidomaterno}`,
                value: confeccionador.rut
            }));
            setConfeccionador(datosFiltrados);
        }
    };

    const obtenerEjecutivos = async () => {
        const response :AxiosResponse<ListResponseDto<ejecutivo>> = await getEjecutivo();
        if (response && response.status === StatusCode.Ok && Array.isArray(response.data.items)) {
            const datosFiltrados = response.data.items.map((ejecutivo: Ejecutivo) => ({
                label: `${ejecutivo.nombres} ${ejecutivo.apellidoPaterno} ${ejecutivo.apellidoMaterno}`,
                value: ejecutivo.rut
            }));
            setEjecutivos(datosFiltrados);
        }
    };

    return {
        obtenerResponsables,
        responsables,
        obtenerEjecutivos,
        ejecutivos,
        obtenerAbogados,
        abogados,
        obtenerConfeccionador,
        confeccionador,
        actualizarResponsable
    };
}